import { AuthService } from '@core/services/auth/auth.service';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Router } from '@angular/router';
import { StepperModule } from 'primeng/stepper';
import { InputOtpChangeEvent, InputOtpModule } from 'primeng/inputotp';
import { FormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { MessageService } from 'primeng/api';
import { TfaType } from '@modules/settings/components/manage-users/interfaces/interfaces';
import { CopyContentComponent } from '@shared/components/copy-content/copy-content.component';

@Component({
  selector: 'app-tfa',
  standalone: true,
  imports: [
    StepperModule,
    InputOtpModule,
    FormsModule,
    ButtonModule,
    CopyContentComponent

],
  templateUrl: './tfa.component.html',
  styleUrl: './tfa.component.scss',
})
export class TfaComponent {
  @Output() backToLoginPageEvent = new EventEmitter();
  @Output() loginEvent = new EventEmitter<string>();
  @Input() isTfaConfigured!: boolean;
  @Input() tfaInputData: TfaType | null = null;

  tfaOtp: string = ''; //this is used to store the tfa otp value
  isNewUser: boolean = this._auth.userDetail().project === null && !this._auth.userDetail().isPasswordUpdatedByUser && !this._auth.userDetail().isTfaConfigured;
  tfaData: any | null = null;
  isVerifying: boolean = false;

  constructor(
    protected _auth: AuthService,
    private router: Router,
    private _messageService: MessageService
  ) {}

  verifyOTP() {
    this.isVerifying = true;
    this._auth.verifyTFA(this._auth.userDetail()._id, this.tfaOtp).subscribe({
        next: (res: any) => {
          this._auth.userDetail.set({
            ...this._auth.userDetail(),
            isPasswordUpdatedByUser: res.isPasswordUpdatedByUser,
            isTfaConfigured: res.isTfaConfigured,
          });
          this.isVerifying = false;
          this.router.navigate(['/']);
          this._messageService.add({
            key: 'tr',
            severity: 'success',
            summary: 'OTP Verified',
            detail: 'OTP verified successfully.',
          });
        },
        error: (err) => {
          this.isVerifying = false;
          this._messageService.add({
            key: 'tr',
            severity: 'warn',
            summary: 'Warning',
            detail: err.error.message || 'Invalid OTP',
          });
        },
      });
  }

  verifyOTPChange(e: InputOtpChangeEvent) {
    if (this.tfaOtp.length === 6){
      if (this.isNewUser) {
        return this.verifyOTP();
      }
      return this.loginEvent.emit(this.tfaOtp);
    }
  }

  backToLoginPage() {
    this.backToLoginPageEvent.emit();
  }
}
